//import { BrowserModule } from '@angular/platform-browser'; 
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatDatepickerModule,
  MatTabsModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatButtonModule,
  MatCardModule,
  MatFormFieldModule,
} from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DpDatePickerModule } from 'ng2-date-picker';
// import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxSpinnerModule } from 'ngx-spinner';

import { ImageUploadComponent } from '../../app/shared/components/image-upload/image-upload.component';
import { DropzoneDirective } from './directives/dropzone.directive';
import { LogService } from './log.service';
import { SharedService } from './shared.service';
import { SecureGuardService } from './security/secure-guard.service';
import { SecurityService } from './security/security.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { UserService } from '../shared/user.service';

@NgModule({
  declarations: [
    ImageUploadComponent,
    DropzoneDirective,
  ],
  imports: [
    //BrowserModule,
    CommonModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTabsModule,
    MatMomentDateModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    // DlDateTimeDateModule,
    // DlDateTimePickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxSpinnerModule,
    CKEditorModule
    //, HttpClientModule
    //, AngularEditorModule
  ],
  exports: [
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    // DlDateTimeDateModule,
    // DlDateTimePickerModule,
    MatDatepickerModule,
    MatTabsModule,
    MatMomentDateModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    NgxSpinnerModule,
    ImageUploadComponent,
    DropzoneDirective,
    CKEditorModule
    // , HttpClientModule
    // , AngularEditorModule
  ],
  providers: [
    LogService,
    SharedService,
    SecureGuardService,
    SecurityService, 
    UserService
  ]
})
export class SharedModule { }
